// extracted by mini-css-extract-plugin
export default {"tasks":"mP-z","task":"nP-z","svg":"oP-z","text":"pP-z"};